import { LoadingStatus } from 'src/enums/webview-loading-status';
import { RootState } from 'src/store/rootStore';
export const selectLoadingStatus = (state: RootState) => state.loading.loadingStatus;
export const selectIsLoadingShow = (state: RootState) =>
    state.loading.loadingStatus !== LoadingStatus.End;
